import { ApplicationState } from '@/store';
import React from 'react';
import { useSelector } from 'react-redux';
import LearningMapCreationButton from './LearningMapCreationButton';
import LearningMapEditingSection from './LearningMapEditingSection';

const LearningMapButton: React.FC = () => {
    const { currentLearningMap } = useSelector((state: ApplicationState) => ({
        currentLearningMap: state.learningMap.data.currentLearningMap,
    }));

    return !!currentLearningMap ? <LearningMapEditingSection /> : <LearningMapCreationButton />;
};

export default LearningMapButton;
